import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_89eiwaa62p: FaireBrandEntity = {
  token: "b_89eiwaa62p",
  type: "brand",
  name: "JILZARAH",
  avatarUrl:
    "https://cdn.faire.com/fastly/e48ec02be2d85ff1751127d6f8b80ff64fbb4ebdd202ebcea552d88dec65d7f7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d6dd8d8adccab233d5c5837713c8ccfc450f17bf840b6493d298ae346f12dfc6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e48ec02be2d85ff1751127d6f8b80ff64fbb4ebdd202ebcea552d88dec65d7f7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d6dd8d8adccab233d5c5837713c8ccfc450f17bf840b6493d298ae346f12dfc6.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 234,
  isTopShop: true,
  isInsider: true,
  description:
    "From vibrant golds and blues to pastel pinks and lavenders, JILZARAH is all about expressing yourself through color and looking amazing while you do it. Every single bead and pattern is the result of hundreds of hours of dedication and passion from our designers. We don't stop until each one is just right and neither do our artisans. Every piece of JILZARAH clay has been handmade so no two are exactly alike and we wouldn't have it any other way :)\n\nWe love color and we love bringing it to you even more. No matter what your race, gender, style, favorite cloud shape, or whatever, we believe you should be free to express yourself and color just happens to be our favorite way to do it.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.399Z",
    importedBy: "entity-db-cli",
  },
};
